export const expression = /[^\w\s]/gi;

export default (input: string): string => input.replace(expression, '');
